<template>
  <ResourceDialog
    @save="gotToFormStepper"
    ref="newFamilyFormDialog"
    :min-width="$vuetify.display.mdAndUp ? '600px' : undefined"
    :processing="processing"
    :save-button-disabled="!newFamilyFormSchemaId"
    save-button-text="Continue"
    title="Submit a form"
    closeable
  >
    <template #description>
      <p class="mb-3">
        {{ $bct(subtitleText) }}
      </p>
    </template>
    <template #form>
      <!-- eslint-disable-next-line prefer-standard-components/no-vuetify-inputs -- TODO migrate to LabeledSelect -->
      <v-select
        v-model="newFamilyFormSchemaId"
        :item-title="(schema) => $bct(schema.name)"
        :items="store.state.familyRequestableFormSchemas"
        :placeholder="$bct('Make a selection')"
        item-value="id"
      />
    </template>
  </ResourceDialog>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';
import useApi from '@/shared/composables/useApi';

const $bct = inject('translator');

const { api } = useApi();
const router = useRouter();
const store = useStore();

const newFamilyFormDialog = ref(null);
const newFamilyFormSchemaId = ref(null);
const processing = ref(false);

const subtitleText = ref(
  "Choose the type of form you need, fill it out, and submit. Once submitted, an administrator will review it. You'll be able to track your form's progress from your dashboard.",
);

const props = defineProps({
  backTo: {
    default: 'Dashboard',
    type: String,
  },
});

function open() {
  newFamilyFormDialog.value.open();
}

async function gotToFormStepper() {
  processing.value = true;
  const formParams = {
    schema_id: newFamilyFormSchemaId.value,
    group_id: store.state.profile.group_id,
  };
  const response = await api.parent.form.create(formParams);
  if (!response?.data) return;

  await router.push({
    name: 'FormContinue',
    params: {
      formId: response.data.id,
      schemaId: response.data.schema_id,
    },
    query: {
      backTo: props.backTo,
    },
  });
}

defineExpose({ open });
</script>
